export const AUTH_HANDLER = Symbol('AUTH_HANDLER');
export const SIGN_IN = Symbol('SIGN_IN');
